<template>
    <div class="home-page-container">
        <!--预加载背景图-->
        <div style="visibility: hidden">
            <div class="choiceYC"></div>
            <div class="prescription"></div>
            <div class="newsMedia"></div>
            <div class="aboutYC"></div>
            <div class="obligationYC"></div>
            <div class="joinUs"></div>

            <div class="freewayMaintain"></div>
            <div class="freewayDecision"></div>
            <div class="normalRoadMaintain"></div>
            <div class="ruralRoadBigData"></div>
            <div class="roadAIMaintain"></div>
            <div class="ruralRoadAutoDetection"></div>
        </div> 
        <div class="header">
            <div class="logo" @click="handleReturnHome">
                <img src="@/assets/image/homePage/yc_logo.png" style="height: 40px;" alt />
            </div>
            <div class="header-nav">
                <div class="nav-item" :style="{ display: item.show ? '' : 'none' }" v-for="(item, index) in navList"
                    :key="index" :class="activeNav === item.page ? 'active' : ''" @click="handleNavClick(item)">{{
                        item.label
                    }}
                </div>
            </div>
            <div class="search-box">
                <i class="el-icon-search"></i>
                <input class="search" />
            </div>
            <div class="register">
                <el-button type="primary" size="mini">登录/注册</el-button>
            </div>

            <!---移动端适配-->
            <div class="mobile-func">
                <div class="mobile-user">
                    <img src="@/assets/image/user_btn.png" alt />
                </div>
                <div class="small-nav" @click="showPanel = !showPanel">
                    <img v-show="!showPanel" src="@/assets/image/table_btn.png" alt />
                    <i v-show="showPanel" class="el-icon-close"></i>
                </div>
            </div>
            <ul class="small-link-panel" v-show="showPanel">
                <li class="small-link-item" v-for="(item, index) in navList" :key="index">
                    <div class="parent" @click="handleMobileNavClick(item)" v-show="item.show">
                        <div class="small-label">{{ item.label }}</div>
                        <div class="icon" v-show="item.children.length > 0" @click.stop="handleShowList(item)">
                            <i v-show="!item.showChildren" class="el-icon-arrow-down"></i>
                            <i v-show="item.showChildren" class="el-icon-arrow-up"></i>
                        </div>
                    </div>
                    <ul class="children" v-show="item.showChildren">
                        <li class="children-item" v-for="(_item, _index) in item.children" :key="_index"
                            @click="handleMobileNavClick(_item)">{{ _item.label }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="header-bg">
            <!-- :class="headerBackground" -->
            <el-carousel class="carousel" height="480px" :interval="5000">
                <el-carousel-item v-for="(item, index) in images" :key="index">
                    <img class="image" :src="require(`@/assets/image/${item}`)" alt="" style="height: 480px;width: 100%;">
                </el-carousel-item>
            </el-carousel>

            <div class="title" v-html="title"></div>
        </div>
        <main class="main" style="position: relative;z-index: 2;">
            <router-view></router-view>
        </main>
        <footer class="footer">
            <div class="logo">
                <img src="@/assets/image/homePage/yc_logo_transparent.png" style="height: 100%;width: 100%;" alt />
            </div>
            <div class="link-container">
                <div class="link-item" v-for="(item, index) in linkList" :key="index">
                    <div class="label">{{ item.label }}</div>
                    <ul class="list">
                        <li class="item" v-for="(c_item, c_index) in item.children" :key="c_index"
                            @click="handleLinkClick(c_item)">{{ c_item.name }}
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <div class="label">联系我们</div>
                    <ul class="list">
                        <li class="item">
                            <div class="name">联系电话：</div>
                            <div class="value">027-59330982</div>
                        </li>
                        <li class="item">
                            <div class="name">客户经理：</div>
                            <div class="value">13317197202</div>
                        </li>
                        <li class="item">
                            <div class="name">公司网址：</div>
                            <div class="value">www.ectit.com</div>
                        </li>
                        <li class="item">
                            <div class="name">公司地址：</div>
                            <div class="value">武汉市东湖高新区武大园路2号徽商大厦B栋1105室</div>
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <div class="label">兰州办事处</div>
                    <ul class="list">
                        <li class="item">
                            <div class="name">联&ensp;系&ensp;人：</div>
                            <div class="value">张经理</div>
                        </li>
                        <li class="item">
                            <div class="name">联系电话：</div>
                            <div class="value">18694066155</div>
                        </li>
                        <li class="item">
                            <div class="name">地&emsp;&emsp;址：</div>
                            <div class="value">甘肃省兰州市七里河区建西西路3501号</div>
                        </li>
                    </ul>
                </div>
                <div class="link-item">
                    <div class="label">西安办事处</div>
                    <ul class="list">
                        <li class="item">
                            <div class="name">联&ensp;系&ensp;人：</div>
                            <div class="value">李经理</div>
                        </li>
                        <li class="item">
                            <div class="name">联系电话：</div>
                            <div class="value">13871083735</div>
                        </li>
                        <li class="item">
                            <div class="name">地&emsp;&emsp;址：</div>
                            <div class="value">西安市碑林区含光路公路局家属院9栋</div>
                        </li>
                    </ul>
                </div>
                <div class="QR-code">
                    <img src="@/assets/image/homePage/yct_QR_code.png" style="height: 100%;width: 100%;" alt />
                    <span>羿畅科技</span>
                </div>
            </div>
            <div class="copy-right">
                <img src="@/assets/image/guohui.png" style="vertical-align: sub;margin-right: 4px" alt />
                <span>鄂ICP备13006194号1@copyright羿畅科技</span>
            </div>
        </footer>
    </div>
</template>

<script>
import { navData, linkData } from './navListData';

export default {
    name: 'homePage',
    data() {
        return {
            showPanel: false,
            title: '人生在勤，勤则不匮',
            activeNav: 'choiceYC',
            headerBackground: 'choiceYC',
            navList: [...navData],
            linkList: [...linkData],
            images: [
                'choiceYC.png',
                'prescription.png',
                'newsMedia.png',
            ],
        };
    },
    /* 
    
    
    */
    mounted() {
        /**
         * isChild为false时，page为父页面名称
         * isChild为true时，page为子{页面的名称，子页面背景}
         */
        this.$bus.$on('changePageTitleAndBackground', ({ page, isChild = false }) => {
            console.log(page);
            if (!isChild) {
                this.activeNav = page;
                this.title = this.navList.find(item => item.page === page).msg;
                this.headerBackground = page;
            } else {
                this.title = page.title;
                this.headerBackground = page.bg;
            }
        });
    },
    beforeDestroy() {
        this.$bus.$off('changePageTitleAndBackground');
    },
    methods: {
        //logo点击
        handleReturnHome() {
            let curr = this.navList.find(_item => _item.page === 'choiceYC');
            this.handleNavClick(curr);
        },
        //移动端导航面板
        handleShowList(item) {
            let curr = this.navList.findIndex(_item => _item.page === item.page);
            this.$set(this.navList, curr, {
                ...item,
                showChildren: !item.showChildren
            });
        },
        //移动端导航点击
        handleMobileNavClick(item) {
            //父节点
            if (item.children != null) {
                this.handleNavClick(item);
            } else {
                let p_curr = this.navList.find(_item => _item.page === item.p_page);
                this.handleNavClick(p_curr);
                this.$nextTick(() => {
                    this.$bus.$emit('selectSystem', item.page);
                });
            }
            this.showPanel = false;
        },

        //导航点击
        handleNavClick(item) {
            this.activeNav = item.page;
            this.$router.push({ name: item.page });
            this.title = item.msg;
            this.images = item.images;

            document.querySelector('.header-bg').scrollIntoView({
                block: 'start'
            });
        },

        //底部导航点击
        handleLinkClick({ p_page, page }) {
            let p_curr = this.navList.find(item => item.page === p_page);
            if (p_curr) {
                this.handleNavClick(p_curr);
                this.$nextTick(() => {
                    this.$bus.$emit('selectSystem', page);
                });
            }
        }
    },
};
</script>

<style lang='scss' scoped>
.home-page-container {
    height: 100%;
    width: 100%;

    .header {
        box-sizing: border-box;
        width: 100%;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        z-index: 3;
        background-color: rgba(3, 3, 3, 0.5);
        backdrop-filter: blur(6px);

        .header-nav {
            color: #ffffff;
            display: flex;
            margin: 0 40px;

            .nav-item {

                white-space: nowrap;
                cursor: pointer;
                padding: 5px 0;
                margin-left: 50px;
                border-bottom: 4px solid;
                display: flex;
                align-items: center;
                border-image: linear-gradient(90deg, #00fefe 0%, #0079fe 100%) 0 0 0 0;

                &:first-child {
                    margin-left: 0;
                }
            }

            .active {
                border-image: linear-gradient(90deg, #00fefe 0%, #0079fe 100%) 2 2 2 2;
            }
        }

        .search-box {
            position: relative;
            margin-right: 50px;

            i {
                position: absolute;
                right: 8px;
                top: 6px;
                color: rgba(255, 255, 255, 0.7);
            }

            .search {
                height: 24px;
                width: 132px;
                outline: none;
                border: 0;
                border-radius: 4px;
                background: rgba(255, 255, 255, 0.5);
                color: #606266;
            }
        }

        .register {
            .el-button--primary {
                background: rgba(0, 121, 254, 0.98);
                border: none;
            }

            .el-button--primary:active {
                background: rgba(0, 121, 254, 0.88);
            }
        }

        .mobile-func {
            display: none;
        }
    }

    .header-bg {
        height: 480px;
        width: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        .carousel ::v-deep .el-carousel__indicators--horizontal {
            bottom: 15%
        }




        .title {
            height: 100%;
            width: 100%;
            color: #ffffff;
            font-size: 40px;
            display: flex;
            align-items: center;
            padding-left: 350px;
            position: absolute;
            z-index: 2;
            pointer-events: none;
        }
    }

    .footer {
        background: #031e3b;
        padding: 70px 100px 70px 100px;

        .logo {
            width: 180px;
        }

        .link-container {
            margin-top: 70px;
            display: flex;
            color: #ffffff;
            justify-content: space-between;

            .link-item {
                .label {
                    font-size: 18px;
                }

                .list {
                    width: 100%;
                    margin-top: 16px;

                    .item {
                        cursor: pointer;
                        padding: 8px 0;
                        font-size: 14px;
                        color: hsla(0, 0%, 100%, 0.6);
                        transition: all 0.2s;
                        display: flex;
                        line-height: 22px;

                        &:hover {
                            color: #1a66ff;
                        }

                        .name {
                            width: 70px;
                            line-height: 22px;
                        }

                        .value {
                            width: 160px;
                            overflow: hidden;
                            line-height: 22px;
                        }

                        @media screen and (max-width: 768px) {
                            .name {
                                width: 70px;
                                line-height: 22px;
                            }

                            .value {
                                width: 100px;
                                overflow: hidden;
                                line-height: 22px;
                            }
                        }

                    }
                }
            }

            .QR-code {
                height: 100px;
                width: 100px;
                text-align: center;
                line-height: 20px;
            }
        }

        .copy-right {
            margin-top: 120px;
            text-align: center;
            color: hsla(0, 0%, 100%, 0.38);
        }
    }
}

//背景图片-预加载
.choiceYC,
.serviceUpgrade {
    background-image: url("~@/assets/image/choiceYC.png");
}

.prescription {
    background-image: url("~@/assets/image/prescription.png");
}

.newsMedia {
    background-image: url("~@/assets/image/newsMedia.png");
}

.aboutYC {
    background-image: url("~@/assets/image/aboutYC.png");
}

.obligationYC {
    background-image: url("~@/assets/image/obligationYC.png");
}

.joinUs {
    background-image: url("~@/assets/image/joinUs.png");
}

.freewayMaintain {
    background-image: url("~@/assets/image/freewayMaintain_bg.png");
}

.freewayDecision {
    background-image: url("~@/assets/image/freewayDecision_bg.png");
}

.normalRoadMaintain {
    background-image: url("~@/assets/image/normalRoadMaintain_bg.png");
}

.ruralRoadBigData {
    background-image: url("~@/assets/image/ruralRoadBigData_bg.png");
}

.roadAIMaintain {
    background-image: url("~@/assets/image/roadAIMaintain_bg.png");
}

.ruralRoadAutoDetection {
    background-image: url("~@/assets/image/ruralRoadAutoDetection_bg.png");
}

@import "./style.scss";
</style>
